module.exports = __webpack_public_path__ + "img/sp-icon-arrow-back.b6e1d856.svg";